// DO NOT EDIT -- generated from fs/services/dataloss/dataloss.proto

import * as cook from '../../cook';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace DatalossInfo {

  export const SummaryEndpoint = "/grpc/dataloss.DatalossInfo/Summary";
  export function Summary(sender: (req: SummaryRequest, endpoint: string) => Promise<SummaryResponse>, req: SummaryRequest): { promise: () => Promise<SummaryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SummaryEndpoint),
      endpoint: SummaryEndpoint
    };
  }

  export const GetDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfo/GetDetectionEventRecord";
  export function GetDetectionEventRecord(sender: (req: GetDetectionEventRecordRequest, endpoint: string) => Promise<GetDetectionEventRecordResponse>, req: GetDetectionEventRecordRequest): { promise: () => Promise<GetDetectionEventRecordResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDetectionEventRecordEndpoint),
      endpoint: GetDetectionEventRecordEndpoint
    };
  }

  export const SetDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfo/SetDetectionEventRecord";
  export function SetDetectionEventRecord(sender: (req: SetDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: SetDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetDetectionEventRecordEndpoint),
      endpoint: SetDetectionEventRecordEndpoint
    };
  }

  export const GetAllInTimeRangeEndpoint = "/grpc/dataloss.DatalossInfo/GetAllInTimeRange";
  export function GetAllInTimeRange(sender: (req: GetAllInTimeRangeRequest, endpoint: string) => Promise<GetAllInTimeRangeResponse>, req: GetAllInTimeRangeRequest): { promise: () => Promise<GetAllInTimeRangeResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllInTimeRangeEndpoint),
      endpoint: GetAllInTimeRangeEndpoint
    };
  }

  export const RemoveDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfo/RemoveDetectionEventRecord";
  export function RemoveDetectionEventRecord(sender: (req: RemoveDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: RemoveDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RemoveDetectionEventRecordEndpoint),
      endpoint: RemoveDetectionEventRecordEndpoint
    };
  }

  export const UpdateDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfo/UpdateDetectionEventRecord";
  export function UpdateDetectionEventRecord(sender: (req: UpdateDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: UpdateDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDetectionEventRecordEndpoint),
      endpoint: UpdateDetectionEventRecordEndpoint
    };
  }

  export const CategorizeDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfo/CategorizeDetectionEventRecord";
  export function CategorizeDetectionEventRecord(sender: (req: CategorizeDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: CategorizeDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CategorizeDetectionEventRecordEndpoint),
      endpoint: CategorizeDetectionEventRecordEndpoint
    };
  }
}

export namespace DatalossInfoPublic {

  export const SummaryEndpoint = "/grpc/dataloss.DatalossInfoPublic/Summary";
  export function Summary(sender: (req: SummaryRequest, endpoint: string) => Promise<SummaryResponse>, req: SummaryRequest): { promise: () => Promise<SummaryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SummaryEndpoint),
      endpoint: SummaryEndpoint
    };
  }

  export const GetDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfoPublic/GetDetectionEventRecord";
  export function GetDetectionEventRecord(sender: (req: GetDetectionEventRecordRequest, endpoint: string) => Promise<GetDetectionEventRecordResponse>, req: GetDetectionEventRecordRequest): { promise: () => Promise<GetDetectionEventRecordResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDetectionEventRecordEndpoint),
      endpoint: GetDetectionEventRecordEndpoint
    };
  }

  export const SetDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfoPublic/SetDetectionEventRecord";
  export function SetDetectionEventRecord(sender: (req: SetDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: SetDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetDetectionEventRecordEndpoint),
      endpoint: SetDetectionEventRecordEndpoint
    };
  }

  export const GetAllInTimeRangeEndpoint = "/grpc/dataloss.DatalossInfoPublic/GetAllInTimeRange";
  export function GetAllInTimeRange(sender: (req: GetAllInTimeRangeRequest, endpoint: string) => Promise<GetAllInTimeRangeResponse>, req: GetAllInTimeRangeRequest): { promise: () => Promise<GetAllInTimeRangeResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllInTimeRangeEndpoint),
      endpoint: GetAllInTimeRangeEndpoint
    };
  }

  export const RemoveDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfoPublic/RemoveDetectionEventRecord";
  export function RemoveDetectionEventRecord(sender: (req: RemoveDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: RemoveDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RemoveDetectionEventRecordEndpoint),
      endpoint: RemoveDetectionEventRecordEndpoint
    };
  }

  export const UpdateDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfoPublic/UpdateDetectionEventRecord";
  export function UpdateDetectionEventRecord(sender: (req: UpdateDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: UpdateDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDetectionEventRecordEndpoint),
      endpoint: UpdateDetectionEventRecordEndpoint
    };
  }

  export const CategorizeDetectionEventRecordEndpoint = "/grpc/dataloss.DatalossInfoPublic/CategorizeDetectionEventRecord";
  export function CategorizeDetectionEventRecord(sender: (req: CategorizeDetectionEventRecordRequest, endpoint: string) => Promise<{}>, req: CategorizeDetectionEventRecordRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CategorizeDetectionEventRecordEndpoint),
      endpoint: CategorizeDetectionEventRecordEndpoint
    };
  }
}

export namespace DataDeletionService {

  export const DeleteTimeRangeEndpoint = "/grpc/dataloss.DataDeletionService/DeleteTimeRange";
  /** DeleteTimeRange deletes all DetectionEventRecords within the [start, end) time. */
  export function DeleteTimeRange(sender: (req: DeleteTimeRangeRequest, endpoint: string) => Promise<{}>, req: DeleteTimeRangeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteTimeRangeEndpoint),
      endpoint: DeleteTimeRangeEndpoint
    };
  }

  export const DeleteTrailingEdgeEndpoint = "/grpc/dataloss.DataDeletionService/DeleteTrailingEdge";
  /** DeleteTrailingEdge deletes all DetectionEventRecords prior to the cutoff time. */
  export function DeleteTrailingEdge(sender: (req: DeleteTrailingEdgeRequest, endpoint: string) => Promise<{}>, req: DeleteTrailingEdgeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteTrailingEdgeEndpoint),
      endpoint: DeleteTrailingEdgeEndpoint
    };
  }

  export const DeleteOrgEndpoint = "/grpc/dataloss.DataDeletionService/DeleteOrg";
  /** DeleteOrg deletes all DetectionEventRecords for the given org. */
  export function DeleteOrg(sender: (req: DeleteOrgRequest, endpoint: string) => Promise<{}>, req: DeleteOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteOrgEndpoint),
      endpoint: DeleteOrgEndpoint
    };
  }
}

export interface DeleteTimeRangeRequest {
  orgId: string;
  start: protobuf.timestamp | null;
  end: protobuf.timestamp | null;
}

export interface DeleteTrailingEdgeRequest {
  orgId: string;
  /** The timestamp before which all data will be deleted from DetectionEventsTable in Bigtable */
  cutoff: protobuf.timestamp | null;
}

export interface DeleteOrgRequest {
  orgId: string;
}

/** Deprecated - use DetectionEventSourceDetail */
export interface EventSourceDetail {
  source: string;
  sourceCount: number;
  elem: string;
}

/** Deprecated - use DetectionEventInfo */
export interface EventInfo {
  datalossType: string;
  /** count of this type of event detail, like "ssn" */
  typeCount: number;
  detail: EventSourceDetail[];
}

export interface DetectionEventSourceDetail {
  source: cook.DatalossSource;
  origin: string;
  selector: string;
  namedElementId: string;
}

export interface DetectionEventInfo {
  detectionType: cook.DatalossType;
  detail: DetectionEventSourceDetail | null;
}

export enum TriageState {
  UNSET = 0,
  NEW = 1,
  RESOLVED = 2
}

export enum Category {
  CATEGORY_UNSET = 0,
  CATEGORY_1 = 1,
  CATEGORY_2 = 2
}

export interface DetectionEventRecord {
  id: string;
  eventInfo: DetectionEventInfo | null;
  triageState: TriageState;
  lastSeen: protobuf.timestamp | null;
  category: Category;
  lastMarkedFixed: protobuf.timestamp | null;
  /** This value is not stored in BigTable and will be computed dynamically on GetAll */
  count: number;
}

export interface GetDetectionEventRecordRequest {
  orgId: string;
  recordId: string;
}

export interface GetDetectionEventRecordResponse {
  detectionEventRecord: DetectionEventRecord | null;
}

export interface SetDetectionEventRecordRequest {
  orgId: string;
  detectionEventRecord: DetectionEventRecord | null;
}

export interface GetAllInTimeRangeRequest {
  orgId: string;
  timeRange: segment.TimeRange | null;
  /** IANA time zone eg. America/New_York */
  timezone: string;
}

export interface GetAllInTimeRangeResponse {
  detectionEventRecords: DetectionEventRecord[];
}

export interface RemoveDetectionEventRecordRequest {
  orgId: string;
  recordId: string;
}

export interface UpdateDetectionEventRecordRequest {
  orgId: string;
  newDetectionEventRecord: DetectionEventRecord | null;
}

export interface CategorizeDetectionEventRecordRequest {
  orgId: string;
  recordId: string;
  category: Category;
}

export interface SummaryRequest {
  /** the json_name option is needed for backwards compatibility */
  orgid: string;
  timeRange: segment.TimeRange | null;
  /** IANA time zone eg. America/New_York */
  timezone: string;
}

export interface SummaryResponse {
  info: EventInfo[];
}
